import { createFeature, createReducer, on } from '@ngrx/store';

import { Container } from 'app/shared/features/container-selector/models';
import { updateContainers } from 'app/state/containers/container.actions';

export const containerFeatureKey = 'container';

export interface ContainerState {
    containerList: Container[];
}

export const initialState: ContainerState = { containerList: [] };

export const reducer = createReducer(
    initialState,
    on(updateContainers, (state, { containerList }) => {
        // Actions of type 'loadContainersSuccess' are dispatched by master-data.service on a regular basis.
        // Here we check if the content for container list has changed. If not then the state does not change.
        // Otherwise, components consuming container list from the state will detect changes, and they will refresh
        // while it is not necessary. It will lead to unpredicted side effect. For example, the components
        // representing the container list will be destroyed and recreated again on every change of the state.
        const currentJson = JSON.stringify(sortContainers(state.containerList));
        const newJson = JSON.stringify(sortContainers(containerList));
        const listChanged = currentJson !== newJson;
        return listChanged
            ? {
                  ...state,
                  containerList: [...containerList],
              }
            : state;
    }),
);

export const containerFeature = createFeature({
    name: containerFeatureKey,
    reducer,
});

function sortContainers(list: Container[]) {
    return [...list].sort((a, b) => a.number - b.number);
}
